import { jsx as _jsx } from "react/jsx-runtime";
import useCopyClipboard from "../../../../../hooks/useCopyClipboard";
import { SubmitButton } from "../../../../../components/Buttons";
const DepositAddressFormButton = ({ values, isValid, error, isSubmitting, showDepositInfo, depositAddress, isProcessing, isCompleted, hasDepositError, onDepositMore, }) => {
    const [copied, copy] = useCopyClipboard();
    if (isCompleted) {
        return (_jsx(SubmitButton, { type: "button", onClick: onDepositMore, children: "Deposit more" }));
    }
    if (isProcessing) {
        return null;
    }
    if (hasDepositError) {
        return (_jsx(SubmitButton, { type: "button", buttonStyle: "secondary", isDisabled: true, children: "Couldn't generate deposit" }));
    }
    if (showDepositInfo && depositAddress) {
        return (_jsx(SubmitButton, { type: "button", onClick: () => copy(depositAddress), children: copied ? 'Copied!' : 'Copy deposit address' }));
    }
    const waitingForAddress = !values?.destination_address;
    const label = error
        || (waitingForAddress ? 'Enter destination address' : 'Generating deposit address');
    return (_jsx(SubmitButton, { type: "button", isDisabled: true, isSubmitting: !waitingForAddress && isValid && !error && isSubmitting, children: label }));
};
export default DepositAddressFormButton;
